import script from "./FilesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./FilesList.vue?vue&type=script&lang=ts&setup=true"

import "./FilesList.vue?vue&type=style&index=0&id=7d9b2fbd&lang=scss"

const __exports__ = script;

export default __exports__